var UtilCookie = /** @class */ (function () {
    function UtilCookie() {
        this.read = function (key, defaultValue) {
            var regex = new RegExp("(^|;)\\s?" + key + "\\s?=\\s?([^;]+)", "g");
            var result = regex.exec(decodeURIComponent(document.cookie));
            var value;
            if (!!result) {
                value = result.pop();
            }
            return value ? value : defaultValue;
        };
        this.write = function (key, value, expires) {
            document.cookie = key + "=" + encodeURIComponent(value) + "; expires=" + expires.toUTCString() + "; path=/";
        };
        /**
         * Clears all cookies. Doesn't handle paths.
         */
        this.clean = function () {
            document.cookie.split(";").forEach(function (cookie) {
                var eqPos = cookie.indexOf("=");
                document.cookie = cookie.substr(0, eqPos) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT;";
            });
        };
    }
    return UtilCookie;
}());
export var utilCookie = new UtilCookie();



//////////////////
// WEBPACK FOOTER
// ./src/utils/utilCookie.ts
// module id = 1688
// module chunks = 3